import React from "react";

import { Building2, Link2, UserPlus, Users } from "lucide-react";

const CRITERIA = [
  {
    id: "sponsor-assignment",
    title: "Sponsor assignment",
    description:
      "You are the primary or secondary executive sponsor (same roster as My Accounts).",
    icon: Building2,
  },
  {
    id: "account-team",
    title: "Account team",
    description: "You are on the vendor account team for that account.",
    icon: Users,
  },
  {
    id: "contact-mappings",
    title: "Your contact mappings",
    description:
      "You have vendor ↔ contact pairs mapped to you in the coverage matrix.",
    icon: Link2,
  },
  {
    id: "additional-sponsor",
    title: "Additional sponsor",
    description: "You are listed as an additional sponsor on the account.",
    icon: UserPlus,
  },
] as const;

const MyRelationshipsEmptyState: React.FC = () => {
  return (
    <div className="flex min-h-[360px] items-center justify-center px-4 py-8">
      <div className="w-full max-w-[640px] rounded-2xl border border-gray-100 bg-white px-6 py-8 text-center shadow-[0_8px_30px_rgba(147,51,234,0.08)] sm:px-10 sm:py-10">
        <div className="mx-auto mb-5 flex h-11 w-11 items-center justify-center rounded-xl bg-violet-100">
          <Building2
            className="h-5 w-5 text-violet-600"
            strokeWidth={1.75}
            aria-hidden
          />
        </div>

        <h3 className="text-lg font-semibold text-gray-900">
          No accounts in your portfolio yet
        </h3>

        <p className="mx-auto mt-3 max-w-[520px] text-sm leading-relaxed text-gray-500">
          This tab shows accounts where{" "}
          <span className="font-medium text-gray-700">you</span> have a
          relationship role—not every account in the org. An account appears
          when any of the following apply:
        </p>

        <ul className="mt-6 space-y-3 text-left">
          {CRITERIA.map(item => {
            const Icon = item.icon;
            return (
              <li
                key={item.id}
                className="flex items-start gap-3 rounded-xl border border-gray-100 bg-white px-4 py-3.5"
              >
                <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-violet-50 text-violet-600">
                  <Icon className="h-4 w-4" strokeWidth={1.75} aria-hidden />
                </span>
                <div className="min-w-0">
                  <p className="text-sm font-semibold text-gray-900">
                    {item.title}
                  </p>
                  <p className="mt-0.5 text-sm leading-relaxed text-gray-500">
                    {item.description}
                  </p>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default MyRelationshipsEmptyState;
